module.exports = __webpack_public_path__ + "img/bg5.f35479b9.jpg";